module.exports = __webpack_public_path__ + "img/29.6b71a587.png";